module.exports = __webpack_public_path__ + "static/img/logo-h.c4737ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/logo-h.png
// module id = qLjZ
// module chunks = 1